import { render, staticRenderFns } from "./recent-projects.vue?vue&type=template&id=618ff10f&scoped=true"
import script from "./recent-projects.vue?vue&type=script&lang=js"
export * from "./recent-projects.vue?vue&type=script&lang=js"
import style0 from "./recent-projects.vue?vue&type=style&index=0&id=618ff10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618ff10f",
  null
  
)

export default component.exports